export default __webpack_public_path__ + "static/media/favourite.6a8f6268.svg";